import type { SVGProps } from 'react';

export const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.08344 10.9986L20.3341 10.9986C20.8861 10.9986 21.3341 11.4466 21.3341 11.9986C21.3341 12.5506 20.8861 12.9986 20.3341 12.9986L6.08079 12.9986L10.0421 16.9599C10.4328 17.3506 10.4328 17.9839 10.0421 18.3746C9.65144 18.7653 9.01811 18.7653 8.62744 18.3746L2.96079 12.708C2.76612 12.5133 2.66746 12.2573 2.66746 12.0013L2.66746 11.9986C2.66746 11.7426 2.76479 11.4866 2.96079 11.292L8.62744 5.6253C9.01811 5.23464 9.65144 5.23464 10.0421 5.6253C10.4328 6.01597 10.4328 6.6493 10.0421 7.03997L6.08344 10.9986Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
